// extracted by mini-css-extract-plugin
export default {"grey40":"#404040","darkGrey":"#4d4d4d","mineShaft":"#252525","green":"#00ddf4","cyan":"#00ddf4"};